export default "__VITE_ASSET__CMtIDxus__"